import React from 'react';
import SectionTitle from './SectionTitle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { ABOUT_ID, PRIMARY_COLOR } from '../constants';
import ServiceButton from './ServiceButton';
import { HOME } from '../../../front/routing';
import OtetsutabiImage from '../../../../images/features/local_delivery/otetsutabi.png';
import StyledTypography from './StyledTypography';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: PRIMARY_COLOR,

    padding: theme.spacing(8, 2, 1),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8, 4, 1),
    },
  },
  contentContainer: {
    margin: `${theme.spacing(4)}px auto`,
    backgroundColor: 'white',
    borderRadius: 10,
    maxWidth: theme.breakpoints.values.lg - 100,

    padding: theme.spacing(4, 2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
    },
  },
  content: {
    display: 'flex',

    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  description: {
    padding: theme.spacing(0),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
      width: '50%',
    },
  },
  subtitle: {
    fontWeight: 'bold',
    paddingBottom: theme.spacing(2),

    fontSize: theme.typography.pxToRem(17),
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(22),
    },
  },
  sentence: {
    fontSize: theme.typography.pxToRem(15),
    paddingBottom: theme.spacing(2),
  },
  imageContainer: {
    textAlign: 'center',

    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
  image: {
    width: '100%',
    maxWidth: 480,

    padding: theme.spacing(4, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
    },
  },
  buttonContainer: {
    textAlign: 'center',
  },
  button: {
    padding: theme.spacing(2, 0),
    width: '100%',
    maxWidth: 420,
  },
}));

const About = () => {
  const classes = useStyles();
  return (
    <div className={classes.root} id={ABOUT_ID}>
      <SectionTitle title="WHAT'S OTETSUTABI?" subtitle="おてつたびについて" />
      <div className={classes.contentContainer}>
        <div className={classes.content}>
          <div className={classes.description}>
            <Typography variant="h3" className={classes.subtitle}>
              お手伝い × 旅 ＝「おてつたび」
            </Typography>
            <StyledTypography className={classes.sentence}>
              「おてつたび」は、人手不足で困っている農家や旅館などの事業者と、地方に興味がある若者をマッチングするweb上のプラットフォームです。
            </StyledTypography>
            <StyledTypography className={classes.sentence}>
              お手伝いすることで報酬を得られるため、旅費自体の削減が可能。
            </StyledTypography>
            <StyledTypography className={classes.sentence}>
              誰でも簡単に、知らない地域に出かけ、お手伝いを通じて地域のファンになって帰る世界を目指しています。
            </StyledTypography>
          </div>
          <div className={classes.imageContainer}>
            <img
              src={OtetsutabiImage}
              alt="若者は地域のお手伝いをし、地域の方々は若者に報酬や寝床、食事などを提供する。"
              className={classes.image}
            />
          </div>
        </div>
        <div className={classes.buttonContainer}>
          <ServiceButton
            classes={{ root: classes.button }}
            rightArrow
            href={HOME}
          >
            おてつたびをもっと知る
          </ServiceButton>
        </div>
      </div>
    </div>
  );
};

export default About;
